import { TicketType } from 'app/shared/typings/ticketTypes';

export const isTicketTypeGeneralAdmission = (ticketType?: TicketType) =>
  ticketType?.name === 'General Admission';

export const isTicketTypeGenericGA = (ticketType: TicketType) =>
  isTicketTypeGeneralAdmission(ticketType) && !ticketType.description;
